export enum SuffixInputType {
    NUMBER = 'number',
    TEXT = 'text',
}